import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=a28591ce&scoped=true"
import script from "./OnDemand.vue?vue&type=script&lang=js"
export * from "./OnDemand.vue?vue&type=script&lang=js"
import style0 from "./OnDemand.vue?vue&type=style&index=0&id=a28591ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28591ce",
  null
  
)

export default component.exports